import cc from 'classcat';
import { jsxs, jsx } from 'react/jsx-runtime';
import { svgCls } from './styles/svg.js';

const FlowerShape = ({
  fillColor = "currentColor",
  shapeRef,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  strokeColor,
  ...svgProps
}) => {
  return /*#__PURE__*/jsxs("svg", {
    ...svgProps,
    className: cc([svgCls, svgProps.className]),
    ref: shapeRef,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 433.4 433.4",
    fill: fillColor,
    children: [/*#__PURE__*/jsx("path", {
      d: "M216.7 112.4l18.7-18.7c20.7-20.7 20.7-54.3 0-75L216.7 0 198 18.7c-20.7 20.7-20.7 54.3 0 75l18.7 18.7zm0 208.5L198 339.6c-20.7 20.7-20.7 54.3 0 75l18.7 18.7 18.7-18.7c20.7-20.7 20.7-54.3 0-75l-18.7-18.7zM369.7 90V63.7h-26.3c-29.1 0-52.7 23.5-52.7 52.5v26.4h26.2c29.1.1 52.7-23.4 52.8-52.5V90zm-306 253.4v26.3H90c29.1 0 52.7-23.5 52.7-52.5v-26.4h-26.2c-29.1-.1-52.7 23.4-52.8 52.5v.1zm313.5-161c-14.1 0-27.6 5.6-37.5 15.5L321 216.6l18.7 18.7c20.7 20.7 54.3 20.7 75 0l18.7-18.7-18.7-18.7c-10-9.9-23.5-15.5-37.5-15.5zm-321 68.5c14.1 0 27.6-5.6 37.5-15.5l18.7-18.7L93.7 198c-20.7-20.7-54.3-20.7-75 0L0 216.7l18.7 18.7c10 10 23.5 15.6 37.5 15.5zm287.2 118.8h26.3v-26.3c0-29.1-23.5-52.7-52.5-52.7h-26.4v26.2c-.1 29.1 23.4 52.7 52.5 52.8h.1zm-226.9-227h26.2v-26.2c.1-29.1-23.4-52.7-52.5-52.8H63.7V90c0 29.1 23.5 52.7 52.5 52.7h.3z"
    }), /*#__PURE__*/jsx("circle", {
      cx: "216.7",
      cy: "216.7",
      r: "43"
    })]
  });
};

export { FlowerShape };
//# sourceMappingURL=FlowerShape.js.map
